export class PublicationsCountersModel {
  constructor(public nbrOfPublished: number,
              public nbrOfUnpublished: number) {}
}
